import * as THREE from "three";
import { BufferGeometry, Line, Line3, MathUtils, Ray, Vector3 } from "three";
import { generateUUID } from "three/src/math/MathUtils";
import { IndserObject, IndsertPosition } from "@/core/IndserObject";
import { MLayer } from "@/core/MLayer";
import {
  DBEntity,
  DbLayer,
  DbLine,
  DrawManager,
  FMathUtils,
  ModelManager,
  ViewManager,
} from "@/CadEngine";
import { BPMathUtils } from "@/utils/BPMathUtils";
import {
  DrawOperateState,
  IDrawOperation,
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
} from "./IDrawOperation";
import { BPLinear } from "@/core/BPLinear";
import { CommonColor, DrawOperateLineParams } from "@/core/Parameters";
import { Context } from "@/core/context";

class DrawOperationRectangle implements IDrawOperation {
  private m_model: ModelManager;
  private m_layer: DbLayer;
  private m_auxLayer: MLayer;
  private m_material: THREE.Material;
  private m_tempObject: THREE.Line | undefined;
  private points: THREE.Vector3[] = [];
  private m_locationObject: THREE.Line;
  private view: ViewManager;
  private m_auxPoints: {
    orgin: THREE.Vector3;
    dir: THREE.Vector3 | undefined;
  }[] = [];
  private ps: THREE.Vector3[] = [];
  private m_draw: DrawManager;
  private m_curPoint: THREE.Vector3 = new THREE.Vector3();
  private m_isDashed: boolean = false;
  private m_context: Context;
  private m_color: number;
  constructor(options: DrawOperateLineParams, isDashed: boolean = false) {
    this.m_model = options.model;
    this.m_layer = options.layer;
    this.m_color = options.color;
    this.m_auxLayer = options.auxLayer;
    this.m_material = new THREE.LineBasicMaterial({
      color: new THREE.Color(options.layer.Color),
    });

    this.m_locationObject =
      options.view.m_context.ToolsManager.CreatedLocationLine();
    this.view = options.view;
    this.m_draw = this.m_model.m_context.DrawManager;
    this.m_isDashed = isDashed;
    this.m_context = this.m_draw.m_context;
    if (isDashed) {
      this.m_material = this.m_context.MaterialManager.createDashedLineMaterial(
        new THREE.Color(options.layer.Color!)
      );
    }
  }

  SetDrawLineForDashed() {}

  onMouseMove(e: PointerEvent): void {}

  onKeyDown(e: KeyboardEvent): void {
    e.preventDefault();
    if (e.key == "Escape") {
      this.m_context.DrawManager.DrawFinish(DrawOperateState.complete);
    }
  }
  onKeyUp(e: KeyboardEvent): void {}

  public get PS() {
    return this.ps;
  }

  OnZoom(camera: THREE.Camera) {
    this.m_auxPoints = [];
  }
  OnWheel(e: WheelEvent): void {}
  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {
    let tolSq = params.tol * params.tol;

    if (this.points.length > 0) {
      let start = new THREE.Vector3();
      let end = new THREE.Vector3();
      let target = new THREE.Vector3();
      let targetOnSegment = new THREE.Vector3();
      let point = this.points[this.points.length - 1];
      if (this.points.length > 1) {
        for (let index = 0; index < this.points.length - 1; index++) {
          start.copy(this.points[index]);
          end.copy(this.points[index + 1]);
          let distance = params.ray.distanceSqToSegment(
            start,
            end,
            target,
            targetOnSegment
          );
          if (distance <= tolSq) {
            let location = {
              x: Number(targetOnSegment.x.toFixed(3)),
              y: Number(targetOnSegment.y.toFixed(3)),
              z: Number(targetOnSegment.z.toFixed(3)),
            };
            let center = new THREE.Vector3(
              (start.x + end.x) * 0.5,
              (start.y + end.y) * 0.5,
              (start.z + end.z) * 0.5
            );
            let d1 = start.distanceTo(targetOnSegment);
            let d2 = center.distanceTo(targetOnSegment);
            let d3 = end.distanceTo(targetOnSegment);
            let position = IndsertPosition.None;
            let min = Math.min(d1, d2, d3);
            let adjust = targetOnSegment.clone();
            if (min <= params.tol) {
              if (min == d1) {
                position = IndsertPosition.Start;
                adjust = start.clone();
              }
              if (min == d2) {
                position = IndsertPosition.Center;
                adjust = center;
              }
              if (min == d3) {
                position = IndsertPosition.End;
                adjust = end.clone();
              }
            }
            let insert = new IndserObject(location, distance, "", []);
            insert.adjust = adjust;
            insert.position = position;
            insert.geo = new THREE.Line3(start.clone(), end.clone());
            params.array.push(insert);
          }
        } // 以上先是用当前移动线检测是否和自己画的线段相交，不包括最后一个线段

        //夹角矫正
        {
          // 这段代码作用为用当前移动线段来和自己画的线的最后一段线检测是否相交
          // alert('yyyyyyyy')
          let direction = new THREE.Vector3();
          this.view.Camera.getWorldDirection(direction);
          let line = new THREE.Line3(
            this.points[this.points.length - 2].clone(),
            this.points[this.points.length - 1].clone()
          );
          let p0 = new THREE.Vector3();
          let p = params.ray.intersectPlane(new THREE.Plane(direction, 0), p0);
          let dir0 = line.end.clone().sub(line.start).normalize();
          let dir1 = p0.clone().sub(line.end).normalize();
          let rad = BPMathUtils.angleTo(dir0, dir1, direction);
          let angle = (rad * 180) / Math.PI;
          let orginLength = p0.distanceTo(line.end);
          let tolAngle = (((params.tol / orginLength) * 180) / Math.PI) * 2; // orginLength越小自动偏转幅度越大

          let offsetAngle = (angle + tolAngle) % 90;
          if (offsetAngle <= tolAngle * 2) {
            //五度之内视为垂直
            rad = rad - ((offsetAngle - tolAngle) * Math.PI) / 180;
            let p = dir0
              .applyAxisAngle(direction, rad)
              .multiplyScalar(p0.distanceTo(line.end));

            p = line.end.clone().add(dir0);
            let insert = new IndserObject(
              p,
              Math.sqrt(params.ray.distanceSqToPoint(p)),
              "",
              []
            );
            insert.adjust = p;
            insert.position = IndsertPosition.AuxOrthogonal;
            params.array.push(insert);
          }
        }
      }
      //正交矫正
      {
        // 这段代码作用为 当只有一个点的时候移动线段和 X轴的相交情况
        let direction = new THREE.Vector3();
        this.view.Camera.getWorldDirection(direction);
        let start = this.points[this.points.length - 1].clone();
        let p0 = new THREE.Vector3();
        params.ray.intersectPlane(new THREE.Plane(direction, 0), p0);
        let dir0 = new THREE.Vector3(1, 0, 0);
        let dir1 = p0.clone().sub(start).normalize();
        let rad = BPMathUtils.angleTo(dir0, dir1, direction);
        let angle = (rad * 180) / Math.PI;
        let orginLength = p0.distanceTo(start);
        let tolAngle = (((params.tol / orginLength) * 180) / Math.PI) * 2;
        let offsetAngle = (angle + tolAngle) % 90;

        if (offsetAngle <= tolAngle * 2) {
          //五度之内视为垂直
          rad = rad - ((offsetAngle - tolAngle) * Math.PI) / 180;
          let p = dir0
            .applyAxisAngle(direction, rad)
            .multiplyScalar(p0.distanceTo(start));
          p = start.clone().add(dir0);
          let insert = new IndserObject(
            p,
            Math.sqrt(params.ray.distanceSqToPoint(p)),
            "",
            []
          );
          insert.adjust = p;
          insert.position = IndsertPosition.AuxOrthogonal;
          // insert.geo = new THREE.Line3(start.clone(), end.clone());
          params.array.push(insert);
        }
      }
    }
    let ray = new THREE.Ray();

    /**
     * 辅助点的吸附点
     */
    if (this.m_auxPoints.length > 0) {
      let normal = new THREE.Vector3(0, 0, 1);
      let panel = new THREE.Plane(normal, 0);
      let insertPoint = new THREE.Vector3();
      params.ray.intersectPlane(panel, insertPoint);

      let func = (line: BPLinear, position: IndsertPosition) => {
        let target = new THREE.Vector3();
        let dis = line.distanceSqPoint(insertPoint, target); //line.distanceSqToRay(params.ray, target);
        if (dis <= tolSq) {
          let insert = new IndserObject(target, Math.sqrt(dis), "", []);
          insert.adjust = target;
          insert.position = position;
          insert.geo = line;
          params.array.push(insert);
        }
      };

      this.m_auxPoints.forEach((item) => {
        if (item.orgin && item.dir) {
          if (
            item.dir.distanceTo(new THREE.Vector3(1, 0, 0)) <= 0.0000001 ||
            item.dir.distanceTo(new THREE.Vector3(-1, 0, 0)) <= 0.0000001 ||
            item.dir.distanceTo(new THREE.Vector3(0, 1, 0)) <= 0.0000001 ||
            item.dir.distanceTo(new THREE.Vector3(0, -1, 0)) <= 0.0000001
          ) {
            func(
              new BPLinear(item.orgin, item.dir),
              IndsertPosition.AuxVertical
            );
            func(
              new BPLinear(
                item.orgin,
                item.dir.clone().applyAxisAngle(normal, Math.PI * 0.5)
              ),
              IndsertPosition.AuxVertical
            );
          } else {
            func(
              new BPLinear(item.orgin, item.dir),
              IndsertPosition.AuxVertical
            );
            func(
              new BPLinear(
                item.orgin,
                item.dir.clone().applyAxisAngle(normal, Math.PI * 0.5)
              ),
              IndsertPosition.AuxVertical
            );
            func(
              new BPLinear(item.orgin, new THREE.Vector3(1, 0, 0)),
              IndsertPosition.AuxOrthogonal
            );
            func(
              new BPLinear(item.orgin, new THREE.Vector3(0, 1, 0)),
              IndsertPosition.AuxOrthogonal
            );
          }
        }
      });
    }

    params.array.forEach((item) => {
      if (item.position == "none") item.position = IndsertPosition.Insert;
      if (item.geo) {
        if (item.geo instanceof THREE.Line3) {
          let line = item.geo as THREE.Line3;
          let p0 = item.adjust ?? item.location;
          let v0 = line.start.clone().sub(line.end.clone());
          let dir0 = v0.clone().normalize();
          if (this.points.length > 0) {
            let point = this.points[this.points.length - 1];
            let v1 = new THREE.Vector3(
              p0.x - point.x,
              p0.y - point.y,
              p0.z - point.z
            );
            let offset = dir0.multiplyScalar(v1.dot(dir0));
            if (offset.lengthSq() <= params.tol * params.tol) {
              //正交矫正
              item.position = IndsertPosition.Vertical;
              item.adjust = new THREE.Vector3(
                p0.x - offset.x,
                p0.y - offset.y,
                p0.z - offset.z
              );
            }
          }
          ray.set(line.start, line.end.clone().sub(line.start).normalize()); // 这里开始检测移动线段是否和场景中两个或两个以上的交点处接触
          params.array.forEach((item1) => {
            if (item1.geo instanceof THREE.Line3) {
              let line1 = item1.geo as THREE.Line3;
              // console.log(params,line,line1,line.start.clone().distanceTo(line1.start.clone()),'!!!!!!!!!');
              if (
                line != line1 &&
                line.start.clone().distanceTo(line1.start.clone()) >
                  0.0000000001 &&
                line.end.clone().distanceTo(line1.end.clone()) >
                  0.00000000001 &&
                line.start.y != line1.end.y
              ) {
                let target = new THREE.Vector3();
                let target1 = new THREE.Vector3();
                let distance = ray.distanceSqToSegment(
                  line1.start.clone(),
                  line1.end.clone(),
                  target
                );
                if (distance < 0.00000000001) {
                  line.closestPointToPoint(target, true, target1); //
                  if (target.distanceTo(target1) < 0.00000001) {
                    // 说明这两条线交叉了，因为这个点同时在两根线上
                    item.position = IndsertPosition.Cross;
                    item.adjust = target;
                    item.distance = target.distanceTo(
                      new THREE.Vector3(
                        item.location.x,
                        item.location.y,
                        item.location.z
                      )
                    );
                  }
                }
              }
            }
          });
        }
      }
    });
  }
  OnMovePoint(params: DrawOperationMovePointParams): void {
    this.m_context.Dom.style.cursor = "none";
    this.m_locationObject.position.copy(params.point);
    this.m_locationObject.visible = true;
    if (!this.points.length) return;
    this.ps = [];
    this.ps.push(...this.points);
    this.m_curPoint = params.point.clone();
    if (this.m_context.DrawManager.isEnableQuadrature && this.points.length) {
      this.m_curPoint = this.m_context.ToolsManager.GetOrthogonalityPoint(
        this.m_curPoint,
        this.points[this.points.length - 1]
      );
    }
    this.computerPs();
    this.updatedTempLine();
  }
  private computerPs(points: THREE.Vector3[] = this.points) {
    let rightTop = new THREE.Vector3(this.m_curPoint.x, points[0].y, 0);
    let leftDown = new THREE.Vector3(points[0].x, this.m_curPoint.y, 0);
    this.ps.push(rightTop);
    this.ps.push(this.m_curPoint);
    this.ps.push(leftDown);
    this.ps.push(...points);
  }

  OnDownPoint(params: DrawOperationMovePointParams): void {
    this.points.push(params.point);
    if (this.points.length == 1) {
      this.createdTempLine();
    }
    if (this.points.length == 2) {
      if (this.m_draw.isEnableQuadrature && params.position !== "none") {
        let tempPoints = [this.points[0]];
        this.ps.length = 0;
        this.m_curPoint = params.point;
        this.ps.push(...tempPoints);
        this.computerPs(tempPoints);
      }
      this.m_draw.DrawFinish(DrawOperateState.complete);
    }
  }
  GetPoints(): Vector3[] {
    return this.points;
  }

  Finish(operate: DrawOperateState): DBEntity | DBEntity[] | undefined {
    this.clear();
    if (this.points.length < 2) return [];
    this.points = this.ps;
    if (operate == DrawOperateState.complete) {
      let key = `${this.m_layer.Id}_${this.m_color}`;
      let lines: DbLine[] = this.m_model.Lines[key]?.lines ?? [];
      let returnLine: DbLine[] = [];
      if (!this.m_isDashed) {
        let ps: number[] = [];
        let index = 0;
        let indexs: number[] = [];
        this.points.forEach((p) => {
          ps.push(p.x, p.y, p.z);
          indexs.push(index);
          if (index != 0 && index != this.points.length - 1) indexs.push(index);
          index++;
        });

        let line = new DbLine({
          id: generateUUID(),
          layerId: this.m_layer.Id,
          blockId: "",
          points: new Float32Array(ps),
          indexes: new Int32Array(indexs),
          color: this.m_color,
        });
        line.getBoundingBox();
        line.getBoundingSphere();
        line.block_path = generateUUID();
        line.extend_id = generateUUID();
        lines.push(line);
        returnLine!.push(line);
      } else {
        let basePoints: {
          startPoint: THREE.Vector3;
          endPoint: THREE.Vector3;
        }[] = [];
        for (let i = 0; i < this.points.length - 1; i++) {
          // 虚线 1500mm 一段
          const point = this.points[i];
          basePoints.push({
            startPoint: point,
            endPoint: this.points[i + 1],
          });
        }
        let dashPoints = [];
        for (let i = 0; i < basePoints.length; i++) {
          let { startPoint, endPoint } = basePoints[i];
          let points =
            this.m_context.ToolsManager.PassStartAndEndPointGetDashPoints(
              startPoint,
              endPoint
            );
          dashPoints.push(points);
        }
        let addLine = this.addLineData(dashPoints);
        returnLine!.push(...addLine);
        lines.push(...addLine);
      }

      if (this.m_model.Lines[key]) {
        this.m_model.Lines[key].lines = lines;
        this.m_context.ToolsManager.LinesToModel(
          lines,
          this.m_model.Lines[key].model
        );
      } else {
        this.m_model.Lines[key] = {
          canEdit: true,
          lines: lines,
          model: this.m_model.addLinesToModel(
            this.m_layer.Id,
            this.m_color,
            lines,
            this.m_isDashed
          ),
        };
      }
      return returnLine;
    } else if (operate == DrawOperateState.cancel) {
      return [];
    }
    return undefined;
  }
  private clear() {
    this.m_context.ToolsManager.ObjectsClear([
      this.m_locationObject,
      this.m_tempObject!,
    ]);
  }

  private addLineData(dashPoints: THREE.Vector3[][]) {
    let dbLinePointsData = [];
    for (let i = 0; i < dashPoints.length; i++) {
      let points = dashPoints[i] as THREE.Vector3[];
      let ps = [];
      let indexs: number[] = [];
      for (let j = 0; j < points.length; j++) {
        let p = points[j];
        ps.push(p.x, p.y, p.z);
        indexs.push(j);
      }
      dbLinePointsData.push({
        points: ps,
        indexs: indexs,
      });
    }
    let lines: DbLine[] = [];
    for (let i = 0; i < dbLinePointsData.length; i++) {
      let line = new DbLine({
        id: generateUUID(),
        layerId: this.m_layer.Id,
        blockId: "",
        points: new Float32Array(dbLinePointsData[i].points),
        indexes: new Int32Array(dbLinePointsData[i].indexs),
        color: this.m_color,
        extend_id: generateUUID(),
      });
      line.getBoundingBox();
      line.getBoundingSphere();
      lines.push(line);
    }
    return lines;
  }

  private get Scale() {
    return this.view.ScreenModelScale;
  }

  private createdTempLine() {
    let geometry = new THREE.BufferGeometry();
    this.m_tempObject = new THREE.Line(geometry, this.m_material);
    this.m_tempObject.frustumCulled = false;
    this.m_auxLayer.add(this.m_tempObject);
  }

  private updatedTempLine() {
    this.m_tempObject?.geometry.setFromPoints(this.ps);
    this.m_tempObject!.computeLineDistances();
  }
}

export { DrawOperationRectangle, DrawOperateLineParams };
